// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
// isInteger is supported in all browsers but IE.

if (!Number.isInteger) {
    Number.isInteger = function(value: any): boolean {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };
}
